import Vue from "vue";
import moment from "moment";
/* eslint-disable */
export default {
    methods: {
        isNull(array){
          return array.join().replace(/,/g,'').length === 0;
        },
        showNotifyWarning(msg, time) {
            new Vue().$vs.notify({
                title: "Atenção",
                text: msg,
                color: "primary",
                icon: "error_outline",
                time: time,
                position: "top-right",
            });
        },        
        showNotifyError(msg, time = 9000) {
            const txtDefault = `Entre em contato com a equipe de atendimento
                para informar o ocorrido através do e-mail:
                atendimento@filoo.com.br ou pelo whatsapp 11 97464-0527.`

            new Vue().$vs.notify({
                title: "Atenção",
                text: msg || txtDefault,
                color: "danger",
                click:() => window.open('https://wa.me/5511974640527', '_blank'),
                time: time,
                icon: "cancel",
                position: "top-right",
            });
        },
        showNotifySuccess(title, msg, time) {
            new Vue().$vs.notify({
                title: title,
                text: msg,
                color: "success",
                icon: "verified_user",
                time: time,
                position: "top-right",
            });
        },
        maskDistance(value) {
            var newValue = parseFloat(value);
            if(newValue>1000){
                return newValue/1000 + " KM";
            }
            else{
                return newValue + " M";
            }
        },
        paymentMethod(value) {
          switch (value) {
            case "bank_slip":
              return "Boleto";
            case "credit_card":
              return "Cartão de Crédito";
            default:
              return "PIX";
          }
        },
        maskMoney(value) {
            var formatter = new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2
            });
            var newValue = parseFloat(value);

            var newValueFormat = formatter.format(newValue);

            return newValueFormat;
        },
        maskMoneyWithoutStyle(value) {
            const formatter = new Intl.NumberFormat("pt-BR", {
                currency: "BRL",
                minimumFractionDigits: 2,
            });
            const newValue = parseFloat(value);

            const newValueFormat = formatter.format(newValue);

            return newValueFormat;
        },
        maskPhone(value) {
            if (value === null || value === undefined || value === "") {
                return "Sem registro";
            }
            const phone = value.replace(/[()\- ]+/gi, '')

            if (phone.length === 11) {
                return `${phone.substr(0, 2)} ${phone.substr(2, 5)} ${phone.substr(7)}`
            }
            return `${phone.substr(0, 2)} ${phone.substr(2, 4)} ${phone.substr(6)}`
        },
        getSplittedDate(date) {
          const splitted = moment(date).format("YYYY/MM/DD").split("/");
          return splitted ;
        },
        maskZipcode(v) {
            if (v === null || v === undefined || v === "") {
                return "";
            } else {
                v = v.replace(/D/g, "")                //Remove tudo o que não é dígito
                v = v.replace(/^(\d{5})(\d)/, "$1-$2") //Esse é tão fácil que não merece explicações
                return v
            }
        },
        maskCelPhone(v) {
            if (v === null || v === undefined || v === "") {
                return "Sem registro";
            } else {
                v = v.replace(/\D/g, "");             		//Remove tudo o que não é dígito
                v = v.replace(/^(\d{2})(\d)/g, "$1 $2"); //Coloca parênteses em volta dos dois primeiros dígitos
                v = v.replace(/(\d)(\d{4})$/, "$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
                return v.substr(0, 15);
            }

        },
        /* eslint-disable */
        maskRg(v) {
            if (v === null || v === undefined || v === "") {
                return "Sem registro"
            }
            else {
                v = v.replace(/\D/g, "");
                v = v.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
                return v;
            }
        },
        testValidName(name) {
            if (this.testNullUndefinedEmpty(name)) {
                return false;
            } else {
                if (this.testFullName(name) == false) {
                    return false;
                }
                if (name.length < 5) {
                    return false;
                }
                if (name.trim().length == 0) {
                    return false;
                }
            }
            return true;
        },
        validateCreditCardNumber(number) {
            if (number === null || number === undefined || number === "") {
                return false;
            }
            else {
                let cardnumber = number.replace(/[^0-9]+/g, '');

                let cards = {
                    visa: /^4[0-9]{12}(?:[0-9]{3})/,
                    mastercard: /^5[1-5][0-9]{14}/,
                    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
                    amex: /^3[47][0-9]{13}/,
                    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
                    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
                    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
                    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
                    aura: /^(5078\d{2})(\d{2})(\d{11})$/
                };

                for (let flag in cards) {
                    if (cards[flag].test(cardnumber)) {
                        console.log(flag);
                        return flag;
                    }
                }

                return false;
            }
        },
        maskCpf(value) {
            if (value === null || value === undefined || value === "") {
                return "Sem registro";
            } else {
                return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
            }
        },
        maskCnpj(value) {
            if (value === null || value === undefined || value === "") {
                return "Sem registro";
            } else {
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
            }
        },
        validateEmail(mail) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
                return (true)
            }
            return (false)
        },
        testFullName(word) {
            const verify = !!word.match(/[A-ZÀ-ú][a-zà-ú]* [A-ZÀ-ú][a-zà-ú]*/)
            return verify;
        },
        onlyFirstLetterCapitalized(text) {
            if (this.testNullUndefinedEmpty(text)) {
                return;
            } else {
                var words = text.toLowerCase().split(" ");
                for (var a = 0; a < words.length; a++) {
                    var w = words[a];
                    words[a] = this.testNullUndefinedEmpty(w[0]) ? "" : w[0].toUpperCase() + w.slice(1);
                }
                return words.join(" ");
            }
        },
        testNullUndefinedEmpty(field) {
            if (field == "" || field == undefined || field == null || field == "null")
                return true;
            else
                return false;
        },
        testFullAddress(address) {
          if(this.testNullUndefinedEmpty(address)){
            return false;
          } else {
            const addressSpaceLocation = address.indexOf(" ");
            const addressSize = address.length;
            if (addressSpaceLocation <= 1 || addressSpaceLocation >= addressSize - 1) {
              return false;
            }
            if(addressSize < 3){
              return false;
            }
            if(address.trim().length == 0){
              return false;
            }
          }
          return true;
        },
        validateCPF(cpf) {
            if (cpf == null || cpf == undefined) return false;
            cpf = cpf.replace(/\D/g, '');
            if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
            var result = true;
            [9, 10].forEach(function (j) {
                var soma = 0, r;
                cpf.split(/(?=)/).splice(0, j).forEach(function (e, i) {
                    soma += parseInt(e) * ((j + 2) - (i + 1));
                });
                r = soma % 11;
                r = (r < 2) ? 0 : 11 - r;
                if (r != cpf.substring(j, j + 1)) result = false;
            });
            return result;
        },
        validateCNPJ(cnpj) {
            if (cnpj == null || cnpj == undefined || cnpj == "") return false;
            cnpj = cnpj.toString().replace(/[^\d]+/g, '');


            if (cnpj.length != 14)
                return false;

            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" ||
                cnpj == "11111111111111" ||
                cnpj == "22222222222222" ||
                cnpj == "33333333333333" ||
                cnpj == "44444444444444" ||
                cnpj == "55555555555555" ||
                cnpj == "66666666666666" ||
                cnpj == "77777777777777" ||
                cnpj == "88888888888888" ||
                cnpj == "99999999999999")
                return false;

            // Valida DVs
            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0, tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;

            tamanho = tamanho + 1;
            numeros = cnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) {
                return false;
            }

            return true;

        },
        formatDate(dateStr) {
            var dArr = null;
            dArr = dateStr.split("-"); // ex input "2010-01-18"
            return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0); //ex out: "18/01/10"
        },
        formatDateHour(dateStr) {
            var dInit = null;
            var dArr = null;
            var dDate = null;
            var dHour = null;
            dInit = dateStr.split(" ");
            dDate = dInit[0];
            dHour = dInit[1];
            dArr = dDate.split("-");
            return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) + " " + dHour.substring(0, 5); //ex out: "18/01/10"
        },
        trim(e) {
            var espacos = /\s/g;
            return e.replace(espacos, "");
        },
        round(value, exp) {
            if (typeof exp === "undefined" || +exp === 0) return Math.round(value);

            value = +value;
            exp = +exp;

            if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0))
                return NaN;

            // Shift
            value = value.toString().split("e");
            value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));

            // Shift back
            value = value.toString().split("e");
            return +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp));
        },
        isDate(input) {
            var status = false;
            if (!input || input.length <= 0) {
                status = false;
            } else {
                var result = new Date(input);
                if (result == 'Invalid Date') {
                    status = false;
                } else {
                    status = true;
                }
            }
            return status;
        },
        getDay(dateHour) {
            return dateHour.substring(0, 10);
        },
        getHour(dateHour) {
            return dateHour.substring(12, 16);
        },
        async getAddressFromLocation(lat, lng) {
            const { data } = await this.axios
              .get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyAdwxi7P7SUDsbcxa3RRcQ315FDIOh1log`);
            const res = data.results[0];
            const count = res.address_components.length - 1;
            const zipCode = res.address_components[count].long_name;
            return {
                lat,
                lng,
                zipCode: zipCode,
                address: res.formatted_address
            };
        },
        async getAddressFromZipCode(zipCode) {
            const { data } = await this.axios
              .get(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=AIzaSyAdwxi7P7SUDsbcxa3RRcQ315FDIOh1log`);
            console.log(data);
            if(data.results.length === 0){
                this.showNotifyError(
                    "CEP inválido",
                    6000
                  );    
            }else{
            const res = data.results[0];
            const loc = res.geometry.location;
            return {
                lat: loc.lat,
                lng: loc.lng,
                zipCode: zipCode,
                address: res.formatted_address
            };
            }
        },
        distanciaEmKms(dist) {
            let res = Math.floor(dist);
            res = dist / 1000;
            if (res > 1) {
                return Math.floor(res) + " km";
            } else {
                res = res * 1000;
                return Math.floor(res) + " m";
            }
        },
    }
}
